import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getIsProductCompareFull,
    getProductCompareChecked,
} from "@insite/client-framework/Store/Components/CompareProductsDrawer/CompareProductsDrawerSelectors";
import addProductToCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/AddProductToCompare";
import removeProductFromCompare from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/RemoveProductFromCompare";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import * as React from "react";
import { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState, props: HasProductContext) => ({
    productCompareChecked: getProductCompareChecked(state, props.productContext),
    isProductCompareFull: getIsProductCompareFull(state),
});

const mapDispatchToProps = {
    addProductToCompare,
    removeProductFromCompare,
};

type OwnProps = ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    WidgetProps &
    HasProductContext;

export interface ProductDetailsCompareProduct {
    compareCheckbox?: CheckboxPresentationProps;
}

const compareProductStyles: ProductDetailsCompareProduct = {
    compareCheckbox: {
        typographyProps: {
            size: 16,
            weight: 700,
        },
        css: css`
            align-self: center;
        `,
    },
};

const styles = compareProductStyles;

const ProductDetailsCompareProduct: React.FC<OwnProps> = ({
    productCompareChecked,
    addProductToCompare,
    removeProductFromCompare,
    isProductCompareFull,
    productContext,
}) => {
    const toasterContext = useContext(ToasterContext);
    const handleChanged = (_: React.SyntheticEvent, value: boolean) => {
        if (value && isProductCompareFull) {
            toasterContext.addToast({
                body: siteMessage("ProductionCompare_MaximumItemsReached"),
                messageType: "warning",
            });
        } else if (value) {
            addProductToCompare({ productId: productContext.product.id });
        } else {
            removeProductFromCompare({ productId: productContext.product.id });
        }
    };
    return (
        <Checkbox
            {...styles.compareCheckbox}
            checked={productCompareChecked}
            onChange={handleChanged}
            data-test-selector="productDetails_CompareCheckbox"
        >
            {translate("ISC_CP-Compare-Product-Details-Page")}
        </Checkbox>
    );
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsCompareProduct)),
    definition: {
        displayName: "Compare Product",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
